<ng-container *ngIf="app == 'Jotto'">
	<mat-card class="q2-report-details-card border border-black border-opacity-12 mb-6" *ngIf="!transcription">
		<mat-card-content>
			<p class="q2-detail-item">
				<strong>Text:</strong>
				<br />
				{{ collectible.textResponse }}
			</p>
		</mat-card-content>
	</mat-card>

	<mat-card class="q2-report-details-card border border-black border-opacity-12 mb-6" *ngIf="transcription">
		<mat-card-content>
			<p class="q2-detail-item">
				<strong>Transcription:</strong>
				<br />
				{{ collectible.transcription_text }}
			</p>
		</mat-card-content>
	</mat-card>
</ng-container>

<ng-container *ngIf="app !== 'Jotto'">
	<mat-card class="q2-report-details-card border border-black border-opacity-12 mb-6">
		<mat-card-title>Report Details</mat-card-title>
		<mat-card-content>
			<!-- Location Section -->
			<h2>Location:</h2>
			<p class="q2-detail-item">
				<strong>Name of city:</strong>
				<br />
				{{ collectible.data?.location_city || 'n/a' | snakeTitle }}
			</p>
			<p class="q2-detail-item">
				<strong>Near by address or landmark:</strong>
				<br />
				{{ collectible.data?.location_address || 'n/a' }}
			</p>

			<h2 [style.margin-top]="'16px'">This incident occured at:</h2>
			<p class="q2-detail-item">
				<strong>Location type:</strong>
				{{ collectible.data?.location_type || 'n/a' | snakeTitle }}
			</p>
			<p class="q2-detail-item">
				<strong>Incident date:</strong>
				{{ collectible.data?.incident_date || 'n/a' | date : 'dd/MM/yyyy' }}
			</p>
			<p class="q2-detail-item">
				<strong>Incident time:</strong>
				{{ collectible.data?.incident_time || 'n/a' | snakeTitle }}
			</p>

			<h2 [style.margin-top]="'16px'">If officer(s) was/were involved:</h2>
			<div *ngIf="app == 'Mobile Justice'">
				<p class="q2-detail-item">
					<strong>Did they identify themselves?</strong>
					<br />
					{{ collectible.data?.officers_identity || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>What agency did they come from?</strong>
					<br />
					{{ collectible.data?.officers_agency || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Was/were the officer(s) violent?</strong>
					<br />
					{{ collectible.data?.officers_violent || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>What type of force was used?</strong>
					<br />
					{{ collectible.data?.force_type || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Was/were the officer(s) profound?</strong>
					<br />
					{{ collectible.data?.officers_profound || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>What happened?</strong>
					<br />
					{{ collectible.data?.what_happened || 'n/a' | snakeTitle }}
				</p>
			</div>
			<div *ngIf="app == 'Y-Stop'">
				<p class="q2-detail-item">
					<strong>What was/were the officer(s) looking for?</strong>
					<br />
					{{ collectible.data?.officer_reason_choice || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>What was their reason?</strong>
					<br />
					{{ collectible.data?.officer_reason_details || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>What happened?</strong>
					<br />
					{{ collectible.data?.what_happened || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Officer(s) badge number(s):</strong>
					<br />
					{{ collectible.data?.officer_badge_numbers || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Officer(s) station:</strong>
					<br />
					{{ collectible.data?.officer_station || 'n/a' | snakeTitle }}
				</p>

				<h2 [style.margin-top]="'16px'">The person stopped</h2>
				<p class="q2-detail-item" *ngIf="collectible.type === type.police_report">
					<strong>Title:</strong>
					{{ collectible.data?.contact_title || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.police_report">
					<strong>First name:</strong>
					{{ collectible.data?.contact_first_name || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.police_report">
					<strong>Last name:</strong>
					{{ collectible.data?.contact_last_name || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.police_report">
					<strong>Date of birth:</strong>
					{{ collectible.data?.contact_date_of_birth || 'n/a' | date : 'dd/MM/yyyy' }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.report">
					<strong>Age:</strong>
					{{ collectible.data?.contact_age || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Gender:</strong>
					{{ collectible.data?.contact_gender || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Ethnicity:</strong>
					{{ collectible.data?.contact_ethnicity || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.police_report">
					<strong>Postcode:</strong>
					{{ collectible.data?.contact_postcode || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.police_report">
					<strong>Address:</strong>
					{{ collectible.data?.contact_address || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item" *ngIf="collectible.type === type.report">
					<strong>Name:</strong>
					{{ collectible.data?.contact_name || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Phone number:</strong>
					{{ collectible.data?.contact_phone || 'n/a' | snakeTitle }}
				</p>
				<p class="q2-detail-item">
					<strong>Email:</strong>
					{{ collectible.data?.contact_email || 'n/a' | snakeTitle }}
				</p>
			</div>
		</mat-card-content>
	</mat-card>
</ng-container>
